import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

import {
  GetImmatriculationFlowsResponse,
  ImmatriculationFlowsResponseSchema,
} from "@/lib/schemas/hrin/immat-flows";

const IMMATRICULATION_FLOWS_ENDPOINT = "/api/hrin/immat/flows";

export const invalidateImmatriculationFlowsQuery = createInvalidateQuery(
  IMMATRICULATION_FLOWS_ENDPOINT,
);

export const useImmatriculationFlowsQuery =
  createQueryHook<GetImmatriculationFlowsResponse>(
    IMMATRICULATION_FLOWS_ENDPOINT,
    ImmatriculationFlowsResponseSchema,
  );
